var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full flex flex-col items-center justify-center"},[_c('p',{staticClass:"text-blue-500 mb-12"},[_vm._v("Loading the component...")]),_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }